<template>
  <q-page class="container" padding>
    <PageHeader
      title="Associar Ferramenta a um Conjunto de Usuários"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div class="row col-3">
      <lista-unidades-select v-model="unidade"></lista-unidades-select>
    </div>
    <div class="row q-mt-md">
      <ferramenta-unica
        @selectValue="getFerramenta"
        :atualizar="refresh"
        class="q-mt-md"
      />

      <table-usuarios-assosiar
        @usuariosSelecionados="getUsuarios"
        @vinculados="getVinculados"
        @userDesvincularId="getUserEspecifico"
        :atualizar="ferramenta"
      />
    </div>
    <q-tabs
      v-model="tab"
      dense
      class="text-grey bg-grey-3 q-mt-xl"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="selecionadas" label="Selecionadas" />
      <q-tab name="associadas" label="Associadas" />
    </q-tabs>
    <q-tab-panels v-model="tab" animated>
      <q-tab-panel name="selecionadas">
        <div>
          <q-table
            flat
            table-header-class="bg-accent text-width-bold"
            class="q-mt-sm tabela-tamanho-fixo"
            :rows="usuariosSelecionados"
            :columns="columns"
            dense
            :loading="disable"
            :rows-per-page-options="[0]"
            hide-bottom
            row-key="id"
            no-data-label
          >
            <template v-slot:bottom>
              <section class="row align">
                <div class="row">
                  <p class="text-h6 text-brand-5">Ferramentas Selecionadas</p>
                </div>
              </section>
            </template>
            <template v-slot:top>
              <section class="row align">
                <div class="row">
                  <p class="text-h6 text-brand-5">
                    Usuarios Selecionados
                    <span v-if="ferramenta"
                      >- {{ ferramenta.nome }} - {{ ferramenta.patrimonio }}
                    </span>
                  </p>
                </div>
              </section>
            </template>
            <template #body-cell-remover="props">
              <q-td>
                <q-btn
                  size="sm"
                  color="red"
                  icon="delete"
                  label="Remover"
                  no-caps
                  @click="remover(props)"
                />
              </q-td>
            </template>
          </q-table>
          <div class="row justify-end">
            <q-btn
              size="md"
              class="q-mt-lg"
              color="positive"
              label="Associar Usuários a Ferramenta"
              no-caps
              @click="Assosiar(props)"
            />
          </div>
        </div>
      </q-tab-panel>

      <q-tab-panel name="associadas">
        <div>
          <q-table
            flat
            table-header-class="bg-accent text-width-bold"
            class="q-mt-sm tabela-tamanho-fixo"
            :rows="ferramentasVinculadas"
            :columns="columns2"
            dense
            :loading="disable"
            :rows-per-page-options="[0]"
            hide-bottom
            row-key="id"
            no-data-label
          >
            <template v-slot:top>
              <section class="row align">
                <div class="row">
                  <p class="text-h6 text-brand-5">
                    Ferramentas Associadas ao usuário:
                  </p>
                </div>
              </section>
            </template>
            <template #body-cell-remover="props">
              <q-td>
                <q-btn
                  size="sm"
                  color="red"
                  icon="delete"
                  label="Remover Associação"
                  no-caps
                  @click="desvincular(props.row.ferramenta_uuid)"
                />
              </q-td>
            </template>
          </q-table>
        </div>
      </q-tab-panel>
    </q-tab-panels>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
  },

  {
    name: "name",
    label: "Usuário",
    field: "name",
    align: "left",
  },
  {
    name: "sap",
    label: "Sap",
    field: "sap",
    align: "left",
  },
  {
    name: "email",
    label: "Email",
    field: "email",
    align: "left",
  },
];

const columns2 = [
  {
    name: "nome_ferramenta",
    label: "Ferramenta",
    field: "nome_ferramenta",
    align: "left",
  },

  {
    name: "nome_vendor",
    label: "Unidade",
    field: "nome_vendor",
    align: "left",
  },
  {
    name: "status_ferramenta",
    label: "Status",
    field: "status_ferramenta",
    align: "left",
  },
  {
    name: "remover",
    label: "Desfazer Associação",
    field: "remover",
    align: "left",
  },
];

import FerramentaUnica from "../components/TableFerramentaUnica.vue";

import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import TableUsuariosAssosiar from "../components/TableUsuariosAssosiar.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: {
    FerramentaUnica,
    TableUsuariosAssosiar,
    ListaUnidadesSelect,
    PageHeader,
  },
  setup() {
    const $q = useQuasar();
    const store = useStore();
    const ferramenta = ref("");
    const usuariosSelecionados = ref([]);
    const ferramentasVinculadas = ref([]);
    const refresh = ref(0);
    let unidade = ref("");

    const tab = ref("selecionadas");
    const userDesvincularId = ref("");

    const getFerramenta = async (value) => {
      if (value) ferramenta.value = await value[0];
    };

    const getVinculados = async (vinculados) => {
      if (vinculados.length == 0) {
        ferramentasVinculadas.value = [];
        return;
      }
      ferramentasVinculadas.value = vinculados[0].ferramentas;
    };

    const getUsuarios = async (usuario) => {
      usuariosSelecionados.value = usuario;
    };

    const getUserEspecifico = async (value) => {
      userDesvincularId.value = value;
    };

    const remover = async (dados) => {
      usuariosSelecionados.value.splice(dados.rowIndex, 1);
    };

    const desvincular = async (idFerramenta) => {
      try {
        await store.dispatch("fer/desvincularFerramenta", {
          idUsuario: userDesvincularId.value,
          idFerramenta: idFerramenta,
        });
        $q.notify({
          message: "Ferramenta Desvinculada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        let retornoId = ferramentasVinculadas.value.findIndex((e) => {
          return e.ferramenta_uuid == idFerramenta;
        });

        ferramentasVinculadas.value.splice(retornoId, 1);
      } catch (error) {
        $q.notify({
          message: "Erro a o desvincular ferramenta",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getFerramenta();
      }
    };

    const Assosiar = async () => {
      try {
        usuariosSelecionados.value.forEach(async (e) => {
          await store.dispatch("fer/assosiarUsuariosFerramentas", {
            uuid_toll: ferramenta.value.uuid,
            user_id: e.id,
          });
        });

        $q.notify({
          message: "Ferramenta Assosiada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        while (usuariosSelecionados.value.length) {
          usuariosSelecionados.value.pop();
        }
        getFerramenta();
        refresh.value++;
      } catch (error) {
        $q.notify({
          message: "Erro a o Assosiar ferramenta",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getUnidadee = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
      }
    );

    onMounted(getUnidadee);

    return {
      getFerramenta,
      getUsuarios,
      usuariosSelecionados,
      columns,
      remover,
      ferramenta,
      ferramentasVinculadas,
      columns2,
      desvincular,
      Assosiar,
      refresh,
      tab,
      getVinculados,
      userDesvincularId,
      getUserEspecifico,
      unidade,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
